const common = {
  // Navigation
  'nav.home': '首页',
  'nav.services': '服务',
  'nav.contact': '联系我们',
  'nav.cta': '获取咨询',
  'nav.tagline': '移民与商务支持',

  // Hero Section
  'hero.badge': '专为中国公民服务',
  'hero.title1': '移居亚美尼亚。',
  'hero.title2': '注册您的企业。',
  'hero.title3': '全程由我们处理。',
  'hero.desc1': '专为希望顺利移居海外、依法注册公司，并获得完善法律与财务支持的中国公民服务——无需独自面对陌生的异国体系。',
  'hero.desc2': '我们是一支驻扎在埃里温的本地团队。我们说您的语言，熟悉当地规则，统筹协调从住房、居留许可到公司注册、财务记账的一切事务。',
  'hero.ctaPrimary': '免费咨询',
  'hero.ctaSecondary': '查看服务',
  'hero.trust1': '驻埃里温本地团队',
  'hero.trust2': '中文、俄文与英文',
  'hero.trust3': '住房 · 商务 · 法律 · 居留',
  'hero.trust4': '长期合作伙伴',

  // Trust Bar
  'trust.t1.title': '驻埃里温本地团队',
  'trust.t1.desc': '真实的本地办公室，而非远程顾问服务',
  'trust.t2.title': '中文服务团队',
  'trust.t2.desc': '全程以中文、俄文及英文沟通',
  'trust.t3.title': '一站式服务',
  'trust.t3.desc': '住房、商务、法律、居留——一个团队全包',
  'trust.t4.title': '从抵达到长期陪伴',
  'trust.t4.desc': '我们在每个阶段全程支持，而非仅限于第一步',

  // About Section
  'about.badge': '关于我们',
  'about.title': '我们是驻扎在埃里温的本地团队，\n而非远程咨询机构。',
  'about.desc1': '我们帮助中国公民移居亚美尼亚、开设企业、寻找住房或办公室，并获得完善的法律、财务及移民支持。所有工作均由我们驻埃里温的内部团队完成——不外包，不远程。',
  'about.desc2': '我们的与众不同之处不在于服务清单，而在于交付方式：我们是一个整合协调的团队，说您的语言，了解您的需求，在初始手续完成后仍长期与您同行。',
  'about.point1': '驻埃里温内部团队——我们对当地市场、法律和人脉了如指掌',
  'about.point2': '中文、俄文、英文——以您偏好的语言全程沟通',
  'about.point3': '无转接、无断档——住房、法律、商务和居留由一个团队统筹协调',
  'about.point4': '入驻后持续支持——提供持续的财务、法律及实务协助',
  'about.floatLabel': '亚美尼亚·埃里温',
  'about.floatDesc': '本地团队驻场服务，而非远程支持',
  'about.whoTitle': '我们的客户群体',
  'about.whoSubtitle': '处于移居各阶段的中国客户',
  'about.client1.title': '个人移居者',
  'about.client1.desc': '为了生活品质、安全、家庭原因或全新开始而移居亚美尼亚的人士。我们负责住房安置、居留许可及日常定居事务。',
  'about.client2.title': '创业者',
  'about.client2.desc': '希望在亚美尼亚注册公司、寻找办公室，并从第一天起拥有完善法律与财务基础设施的企业主。',
  'about.client3.title': '公司与投资者',
  'about.client3.desc': '寻求可靠本地合作伙伴以管理合规事务、拓展业务运营，或亲身了解亚美尼亚商业环境的机构客户。',

  // Services Preview
  'servicesPreview.badge': '我们的服务',
  'servicesPreview.title': '我们提供的服务',
  'servicesPreview.desc': '所有服务均由我们驻埃里温的内部团队交付——可根据需要协同推进，也可单独处理某项任务。',
  'servicesPreview.seeDetails': '查看详情',
  'servicesPreview.viewAll': '查看全部服务',
  'servicesPreview.s1.title': '住房搜寻',
  'servicesPreview.s1.desc': '我们根据您的预算、区位偏好和时间安排，在埃里温为您寻找公寓或独栋住宅，并代为处理谈判与租约审核。',
  'servicesPreview.s2.title': '办公室搜寻',
  'servicesPreview.s2.desc': '从联合办公工位到私人办公室和全包式办公空间——我们筛选方案、协调看房并协助完成租赁流程。',
  'servicesPreview.s3.title': '公司注册',
  'servicesPreview.s3.desc': '我们全程管理亚美尼亚公司注册流程：选择法律形式、准备文件、税务登记及注册后续手续。',
  'servicesPreview.s4.title': '法律与财务支持',
  'servicesPreview.s4.desc': '持续的法律咨询与专业财务记账，确保您的企业合规运营——由我们的内部团队负责，而非外包。',
  'servicesPreview.s5.title': '居留许可',
  'servicesPreview.s5.desc': '我们评估您的情况，准备相应文件，并与移民主管部门协调，为您办理或续签在亚美尼亚的居留身份。',
  'servicesPreview.s6.title': '持续本地支持',
  'servicesPreview.s6.desc': '入驻完成后，我们继续作为您的联系人，处理咨询、续签、法律变更及在亚美尼亚生活或经营中出现的各类实务问题。',

  // Why Armenia
  'whyArmenia.badge': '为何选择亚美尼亚',
  'whyArmenia.title': '为何越来越多中国公民和创业者选择亚美尼亚',
  'whyArmenia.desc1': '亚美尼亚不是一个折衷之选——对于那些希望拥有友好商业环境、真实生活品质和合法居留途径的人而言，这是一个务实的选择。',
  'whyArmenia.desc2': '低廉的公司注册成本、透明的法律框架，以及对外国公民的包容态度，使其成为正在构建国际布局的中国公民最被低估的目的地之一。',
  'whyArmenia.cta': '咨询亚美尼亚相关事宜',
  'whyArmenia.r1.title': '公司注册简便',
  'whyArmenia.r1.desc': '亚美尼亚公司可在数个工作日内完成注册，流程清晰、文件齐全，全程无需本人在场。',
  'whyArmenia.r2.title': '具竞争力的税收环境',
  'whyArmenia.r2.desc': '亚美尼亚为外资企业、个体创业者及IT行业经营者提供透明、税负相对较低的营商环境，规则明确。',
  'whyArmenia.r3.title': '战略地理位置',
  'whyArmenia.r3.desc': '地处欧洲、俄罗斯与中东的交汇处，亚美尼亚是在多个地区拥有业务的企业的理想中转基地。',
  'whyArmenia.r4.title': '华人社区持续壮大',
  'whyArmenia.r4.desc': '埃里温已有成熟且不断壮大的华人商业社区，中餐馆、供应商及专业网络一应俱全。',
  'whyArmenia.r5.title': '生活成本可承受',
  'whyArmenia.r5.desc': '与亚洲或欧洲主要城市相比，埃里温的住房、办公室租金及日常消费对个人和各规模企业均极具性价比。',
  'whyArmenia.r6.title': '稳定且包容的环境',
  'whyArmenia.r6.desc': '亚美尼亚对外国居民和创业者持开放态度，中国公民可在相对较少的行政障碍下居住和经营企业。',

  // Why Us
  'whyUs.badge': '为何选择我们',
  'whyUs.title': '为何客户选择我们\n而非各类单独专家',
  'whyUs.desc': '与我们合作，意味着您只需对接一个可信赖的团队，而无需协调多个互不沟通的服务商。这一根本区别为您节省时间、减少失误，让整个流程压力大幅降低。',
  'whyUs.r1.title': '一个流程，而非六个分散服务商',
  'whyUs.r1.desc': '大多数人最终要分别管理律师、房产中介、会计和签证代理。我们统筹协调一切——更快出结果、更少衔接断层、告别相互矛盾的建议。',
  'whyUs.r2.title': '从内部了解亚美尼亚',
  'whyUs.r2.desc': '我们的团队在埃里温生活和工作。我们清楚哪些社区适合哪种生活方式，哪家银行能快速为中国公民开户，以及如何不走弯路地处理本地行政事务。',
  'whyUs.r3.title': '无语言障碍',
  'whyUs.r3.desc': '所有咨询、文件和持续沟通均可以中文进行。我们也可以用俄文和英文工作，确保信息零失真。',
  'whyUs.r4.title': '法律精准，而非单纯求快',
  'whyUs.r4.desc': '我们在法律合规方面绝不走捷径。您的公司注册、居留许可和财务记账从一开始就按正确方式处理，避免日后出现问题。',
  'whyUs.r5.title': '入驻后持续陪伴',
  'whyUs.r5.desc': '公司注册完毕、住房合同签署后，问题仍会不断涌现。我们持续作为您的联系人，处理法律更新、税务问题、续签手续及一切新增需求。',

  // How We Work
  'howWeWork.badge': '我们的工作流程',
  'howWeWork.title': '我们如何与您协作',
  'howWeWork.desc': '一套稳定一致的流程，避免意外，让您在每个阶段都掌握主动。',
  'howWeWork.s1.number': '01',
  'howWeWork.s1.title': '初步咨询',
  'howWeWork.s1.desc': '我们从一次免费对话开始，了解您的情况、目标和时间安排。咨询结束后，您将清晰掌握接下来涉及的内容和后续步骤。',
  'howWeWork.s2.number': '02',
  'howWeWork.s2.title': '个性化行动方案',
  'howWeWork.s2.desc': '我们为您的具体情况制定专属计划——需要哪些服务、按什么顺序推进、需准备哪些文件，以及切实可行的时间预期。',
  'howWeWork.s3.number': '03',
  'howWeWork.s3.title': '执行与协调',
  'howWeWork.s3.desc': '我们负责落地执行——寻找住房、注册公司、准备居留文件，以及协调律师、会计和相关主管机构。',
  'howWeWork.s4.number': '04',
  'howWeWork.s4.title': '持续支持',
  'howWeWork.s4.desc': '初始安置完成后，我们持续作为您的本地合作伙伴——处理财务、续签、法律咨询及后续出现的一切新需求。',

  // FAQ
  'faq.badge': '常见问题',
  'faq.title': '常见问题解答',
  'faq.desc': '针对客户最常提出问题的务实解答。',
  'faq.q1': '抵达亚美尼亚前可以开始与您合作吗？',
  'faq.a1': '可以——大多数客户正是这样做的。我们可以远程处理整个抵达前的流程：初步咨询、公司注册、住房候选清单、银行开户准备以及居留文件，均可在您登机前启动。您抵达时，一切已大致准备就绪。',
  'faq.q2': '完整的移居和企业注册流程需要多长时间？',
  'faq.a2': '亚美尼亚公司注册通常需要3至7个工作日。寻找并确定住房因个人需求和市场情况而异，但大多数客户可在2至4周内安顿完毕。居留许可因类型不同，通常需要数周时间处理。我们会在开始时提供切实的时间预期，并全程及时更新进展。',
  'faq.q3': '你们可以协助在亚美尼亚开立银行账户吗？',
  'faq.a3': '可以。我们将为您详细介绍银行开户流程，包括哪些银行对中国公民更友好、所需文件及准备要点。根据您的情况，我们会全程陪同或提供清晰的准备材料。',
  'faq.q4': '合作前需要准备哪些文件？',
  'faq.a4': '这取决于您的具体需求——公司注册、住房或居留许可各有不同要求。在合作开始时，我们会为您提供清晰的个性化文件清单，确保不留盲区。我们也会协助您准备和认证相关文件。',
  'faq.q5': '你们提供中文支持吗？',
  'faq.a5': '是的。我们的团队在整个服务过程中全程以中文沟通——包括咨询、文件说明、进展更新和后续问题解答。如有需要，我们也可以用俄文或英文服务。',
  'faq.q6': '可以同时使用多项服务吗？',
  'faq.a6': '可以，这通常也是最高效的方式。许多客户同步进行公司注册、办公室寻找和居留许可申请。我们统筹协调时间节点，确保各项工作流互不冲突——往往还能相互加速推进。',
  'faq.q7': '初步安置完成后会发生什么？',
  'faq.a7': '我们不会将您移交后一走了之。许多客户在此后持续与我们合作，涵盖持续记账、法律支持、居留续签及在亚美尼亚运营相关的各类问题解答。我们是长期合作伙伴，而非一次性服务。',
  'faq.q8': '我还在评估是否移居亚美尼亚，可以联系你们吗？',
  'faq.a8': '当然——这也是最常见的第一步。我们可以为您客观介绍移居和企业注册的实际情况，包括费用、时间和要求。无需承诺，没有压力。我们很多长期客户都是从一次轻松的探索性对话开始的。',

  // Final CTA
  'finalCta.badge': '准备好开始了吗？',
  'finalCta.title': '告诉我们您的需求，\n我们告诉您能做什么。',
  'finalCta.desc': '无论您仍在探索还是已准备好出发——联系我们，我们将为您提供清晰、诚实的选项概述。无需承诺，不作空泛承诺。',
  'finalCta.primary': '发送需求',
  'finalCta.secondary': '查看服务',

  // Footer
  'footer.tagline': '驻埃里温本地团队，专为中国公民提供移居、企业注册及合法居留支持。住房、法律、财务及居留许可——一站式全覆盖。',
  'footer.services': '服务',
  'footer.navigation': '导航',
  'footer.contact': '联系方式',
  'footer.location': '亚美尼亚·埃里温',
  'footer.copyright': '版权所有。',
  'footer.motto': '专为在亚美尼亚的中国公民提供移居与商务支持',
  'footer.s1': '住房搜寻',
  'footer.s2': '办公室搜寻',
  'footer.s3': '公司注册',
  'footer.s4': '法律支持',
  'footer.s5': '财务支持',
  'footer.s6': '居留许可',
  'footer.email': '电子邮件',
  'footer.telegram': 'Telegram',

  // Services Page
  'servicesPage.heroNav': '首页',
  'servicesPage.heroNavCurrent': '服务',
  'servicesPage.heroTitle': '专为在亚美尼亚的\n中国公民提供的服务',
  'servicesPage.heroDesc': '为移居、企业注册及合法居留提供务实支持——从住房和办公室搜寻到公司注册、法律、财务及居留许可。',
  'servicesPage.ctaTitle': '需要单项服务还是全面支持？',
  'servicesPage.ctaDesc': '告诉我们您的情况，我们将推荐最适合的方案——无论是单一服务还是完整的移居套餐。',
  'servicesPage.ctaBtn': '讨论您的需求',

  // Services List
  'sl.s1.title': '在亚美尼亚寻找住房',
  'sl.s1.desc': '找到合适的公寓或住宅往往是移居的第一个实际步骤。埃里温的租房市场节奏较快，没有本地人脉单独搜寻费时费力。我们为您全权负责搜寻、筛选和协调工作。',
  'sl.s1.d1': '详细需求确认——了解您的要求、预算和偏好区域',
  'sl.s1.d2': '根据您的条件筛选房源，提供精选推荐清单',
  'sl.s1.d3': '安排看房并翻译与房东的沟通内容',
  'sl.s1.d4': '签约前协助租约谈判与审核',
  'sl.s1.d5': '协助水电开通及入住实务事宜',
  'sl.s1.cta': '咨询住房方案',
  'sl.s2.title': '为企业寻找办公室',
  'sl.s2.desc': '无论您需要用于注册的商业地址、独立办公室还是联合办公空间，我们均可为您筛选合适方案，并全程管理从搜寻到签订协议的整个流程。',
  'sl.s2.d1': '了解您的办公需求和时间安排',
  'sl.s2.d2': '搜寻独立办公室、全包式办公空间和联合办公选项',
  'sl.s2.d3': '协调看房并协助谈判',
  'sl.s2.d4': '租约审核与签署支持',
  'sl.s2.d5': '如有需要，为公司注册目的提供注册地址服务',
  'sl.s2.cta': '了解办公室方案',
  'sl.s3.title': '在亚美尼亚注册企业',
  'sl.s3.desc': '亚美尼亚注册流程简便，启动成本低，对外资企业的税收条件相对有利。我们全程管理——从选择合适的法律架构到收到注册文件。',
  'sl.s3.d1': '根据您的商业模式和目标选择合适的法律主体',
  'sl.s3.d2': '准备并提交所有注册文件',
  'sl.s3.d3': '税务登记及纳税人识别号申请',
  'sl.s3.d4': '企业银行开户指导',
  'sl.s3.d5': '注册后关于义务、报告和后续步骤的说明',
  'sl.s3.cta': '开始注册',
  'sl.s4.title': '法律支持',
  'sl.s4.desc': '进入新的法律环境，难免遇到合同、雇佣、公司架构或合规方面的问题。我们的法律团队提供以现行亚美尼亚法律为基础的务实指导，而非泛泛而谈的建议。',
  'sl.s4.d1': '以亚美尼亚语、俄文或英文起草和审核合同',
  'sl.s4.d2': '公司架构和股东协议咨询',
  'sl.s4.d3': '劳动法指导和本地劳工合规',
  'sl.s4.d4': '知识产权注册和基本保护指导',
  'sl.s4.d5': '如有需要，代理并协调本地主管机构事务',
  'sl.s4.cta': '提出法律问题',
  'sl.s5.title': '财务支持',
  'sl.s5.desc': '亚美尼亚每家注册公司都有持续的税务和报告义务。我们的财务团队处理您的记账、报税和薪资事务，让您在合规的前提下无需自行花时间应付。',
  'sl.s5.d1': '月度记账和财务报表编制',
  'sl.s5.d2': '向亚美尼亚税务机关提交纳税申报',
  'sl.s5.d3': '薪资处理和员工税务事项',
  'sl.s5.d4': '增值税登记和定期申报',
  'sl.s5.d5': '在法律框架内的税务优化建议',
  'sl.s5.cta': '获取财务支持',
  'sl.s6.title': '合法化与居留许可',
  'sl.s6.desc': '在亚美尼亚获得并维持合法居留身份，涉及特定文件、截止日期以及与移民主管机构的协调。我们评估您的情况，确保准备工作准确无误，并全程跟踪至办理完成。',
  'sl.s6.d1': '评估最适合您情况的居留许可类型',
  'sl.s6.d2': '全套文件准备，如需提供翻译',
  'sl.s6.d3': '向亚美尼亚移民局提交申请并协调跟进',
  'sl.s6.d4': '状态监控和主动续签提醒',
  'sl.s6.d5': '为首次抵达的中国公民提供入境咨询',
  'sl.s6.cta': '了解您的资格',

  // Work Formats
  'wf.badge': '合作方式',
  'wf.title': '选择适合您的支持级别',
  'wf.desc': '无论您只需解答单个问题，还是需要全程管理移居事务——我们都有合适的合作模式。',
  'wf.popular': '最受欢迎',
  'wf.f1.title': '一次性咨询',
  'wf.f1.subtitle': '适合初步了解',
  'wf.f1.desc': '一次深度对话，帮助您了解选项、评估所涉及的内容，并决定是否——以及如何——继续推进。无需任何承诺。',
  'wf.f1.feat1': '最长60分钟，可远程或面对面进行',
  'wf.f1.feat2': '针对您具体问题的诚实解答',
  'wf.f1.feat3': '时间、费用和要求的概况介绍',
  'wf.f1.feat4': '书面总结和推荐的后续步骤',
  'wf.f1.cta': '预约咨询',
  'wf.f2.title': '单项服务支持',
  'wf.f2.subtitle': '适合单一明确任务',
  'wf.f2.desc': '针对单一服务的全程端到端支持——住房搜寻、公司注册、居留许可或其他具体任务——范围和时间线清晰明确。',
  'wf.f2.feat1': '完整处理一项明确服务',
  'wf.f2.feat2': '包含所有文件、协调和沟通',
  'wf.f2.feat3': '全程定期更新进展',
  'wf.f2.feat4': '完成后如有问题可提供简短咨询',
  'wf.f2.cta': '讨论单项服务',
  'wf.f3.title': '全面支持套餐',
  'wf.f3.subtitle': '适合完整移居与企业注册',
  'wf.f3.desc': '我们最全面的合作模式。我们统筹协调您的整个移居和企业注册过程——住房、办公室、公司注册、法律、财务和居留——作为一个统一流程推进。',
  'wf.f3.feat1': '一次合作涵盖所有相关服务',
  'wf.f3.feat2': '全程单一联系人',
  'wf.f3.feat3': '住房、法律和商务事务的协调时间线',
  'wf.f3.feat4': '优先沟通和长期持续支持',
  'wf.f3.cta': '讨论全面支持',

  // Contact Page
  'contact.heroNav': '首页',
  'contact.heroNavCurrent': '联系我们',
  'contact.heroTitle': '与我们联系',
  'contact.heroDesc': '简要告诉我们您的需求——移居、住房、公司注册、法律或财务支持，或居留许可。我们将以清晰、诚实的方式回复您的选项概述。',
  'contact.reachTitle': '直接联系我们',
  'contact.reachDesc': '选择您最方便的沟通方式。我们以中文、俄文和英文沟通，并在一个工作日内回复。',
  'contact.officeTitle': '我们的办公室',
  'contact.officeLocation': '亚美尼亚共和国·埃里温',
  'contact.officeNote': '预约后可安排面对面会谈',
  'contact.responseNote': '我们在一个工作日内回复所有咨询。如需更快沟通，WhatsApp和Telegram是最快的渠道。',
  'contact.formTitle': '发送需求',
  'contact.formDesc': '告诉我们您的需求，我们将回复清晰的支持概述及流程说明。',
  'contact.successTitle': '需求已收到',
  'contact.successDesc': '感谢您的联系。我们将审阅您的需求，并在一个工作日内回复。',
  'contact.labelName': '姓名',
  'contact.labelContact': '电话 / WhatsApp / 微信',
  'contact.labelEmail': '电子邮件',
  'contact.labelService': '您需要什么帮助？',
  'contact.labelComment': '您的情况或问题',
  'contact.placeholderName': '您的姓名',
  'contact.placeholderContact': '您偏好的联系方式或账号',
  'contact.placeholderEmail': 'your@email.com',
  'contact.placeholderService': '选择最相关的选项',
  'contact.placeholderComment': '简要描述您的情况、时间安排或具体问题。您提供的背景越多，我们的回复越有帮助。',
  'contact.errorMsg': '出现错误，请重试或直接通过电子邮件联系我们。',
  'contact.btnSend': '发送需求',
  'contact.btnSending': '发送中……',
  'contact.privacy': '提交此表单即表示您同意我们的团队就您的咨询与您联系。',
  'contact.maxLength': '最多500个字符。',
  'contact.opt1': '住房搜寻',
  'contact.opt2': '办公室搜寻',
  'contact.opt3': '公司注册',
  'contact.opt4': '法律支持',
  'contact.opt5': '财务支持',
  'contact.opt6': '合法化与居留许可',
  'contact.opt7': '全面支持套餐',
  'contact.opt8': '初步咨询——我有问题想了解',

  // Language switcher
  'lang.en': 'EN',
  'lang.zh': '中文',

  // SEO — Home
  'seo.home.title': 'ArmeniaSettle — 专为中国公民提供亚美尼亚移居与商务支持',
  'seo.home.description': '我们帮助中国公民移居亚美尼亚、创立企业——提供住房搜寻、办公室搜寻、公司注册、法律与财务支持及居留许可办理服务。驻埃里温本地团队。',

  // SEO — Services
  'seo.services.title': '服务项目 — 亚美尼亚住房搜寻、公司注册与法律支持 | ArmeniaSettle',
  'seo.services.description': '专为在亚美尼亚的中国公民提供务实支持：住房搜寻、办公室搜寻、公司注册、法律与财务支持及居留许可办理。一个团队，全程覆盖。',

  // SEO — Contact
  'seo.contact.title': '联系我们 — ArmeniaSettle | 亚美尼亚·埃里温',
  'seo.contact.description': '通过Telegram或电子邮件联系ArmeniaSettle团队。我们在一个工作日内回复，支持中文、俄文和英文沟通。可在埃里温预约面对面会谈。',
};

export default common;
